module.exports = __webpack_public_path__ + "img/Setting.798446fd.svg";